/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  BarChartStats,
  FleetMembersStats,
  FleetMembersStatsParams,
  FleetMembersStatsPublic,
  FleetModelCountsParams,
  FleetModelCountsStats,
  FleetVehiclesStats,
  PieChartStats,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Fleet Members Stats
 */
export const fleetMembersStats = (
    fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetMembersStatsParams>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
params = toValue(params);

      return axiosClient<FleetMembersStats>(
      {url: `/fleets/${fleetSlug}/stats/members`, method: 'GET',
        params, signal
    },
      );
    }




export const getFleetMembersStatsQueryKey = (fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetMembersStatsParams>,) => {
    return [
    'fleets',fleetSlug,'stats','members', ...(params ? [params] : [])
    ] as const;
    }


export const getFleetMembersStatsQueryOptions = <TData = Awaited<ReturnType<typeof fleetMembersStats>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetMembersStatsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetMembersStats>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetMembersStatsQueryKey(fleetSlug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetMembersStats>>> = ({ signal }) => fleetMembersStats(fleetSlug,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetMembersStats>>, TError, TData>
}

export type FleetMembersStatsQueryResult = NonNullable<Awaited<ReturnType<typeof fleetMembersStats>>>
export type FleetMembersStatsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleet Members Stats
 */

export function useFleetMembersStats<TData = Awaited<ReturnType<typeof fleetMembersStats>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetMembersStatsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetMembersStats>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetMembersStatsQueryOptions(fleetSlug,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Fleet Stats Model Counts
 */
export const fleetModelCounts = (
    fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetModelCountsParams>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
params = toValue(params);

      return axiosClient<FleetModelCountsStats>(
      {url: `/fleets/${fleetSlug}/stats/model-counts`, method: 'GET',
        params, signal
    },
      );
    }




export const getFleetModelCountsQueryKey = (fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetModelCountsParams>,) => {
    return [
    'fleets',fleetSlug,'stats','model-counts', ...(params ? [params] : [])
    ] as const;
    }


export const getFleetModelCountsQueryOptions = <TData = Awaited<ReturnType<typeof fleetModelCounts>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetModelCountsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetModelCounts>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetModelCountsQueryKey(fleetSlug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetModelCounts>>> = ({ signal }) => fleetModelCounts(fleetSlug,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetModelCounts>>, TError, TData>
}

export type FleetModelCountsQueryResult = NonNullable<Awaited<ReturnType<typeof fleetModelCounts>>>
export type FleetModelCountsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleet Stats Model Counts
 */

export function useFleetModelCounts<TData = Awaited<ReturnType<typeof fleetModelCounts>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetModelCountsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetModelCounts>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetModelCountsQueryOptions(fleetSlug,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Fleet Stats - Models by Classification
 */
export const fleetModelsByClassification = (
    fleetSlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);

      return axiosClient<PieChartStats[]>(
      {url: `/fleets/${fleetSlug}/stats/models-by-classification`, method: 'GET', signal
    },
      );
    }




export const getFleetModelsByClassificationQueryKey = (fleetSlug: MaybeRefOrGetter<string>,) => {
    return [
    'fleets',fleetSlug,'stats','models-by-classification'
    ] as const;
    }


export const getFleetModelsByClassificationQueryOptions = <TData = Awaited<ReturnType<typeof fleetModelsByClassification>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetModelsByClassification>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetModelsByClassificationQueryKey(fleetSlug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetModelsByClassification>>> = ({ signal }) => fleetModelsByClassification(fleetSlug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetModelsByClassification>>, TError, TData>
}

export type FleetModelsByClassificationQueryResult = NonNullable<Awaited<ReturnType<typeof fleetModelsByClassification>>>
export type FleetModelsByClassificationQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleet Stats - Models by Classification
 */

export function useFleetModelsByClassification<TData = Awaited<ReturnType<typeof fleetModelsByClassification>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetModelsByClassification>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetModelsByClassificationQueryOptions(fleetSlug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Fleet Stats - Models by Manufacturer
 */
export const fleetModelsByManufacturer = (
    fleetSlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);

      return axiosClient<PieChartStats[]>(
      {url: `/fleets/${fleetSlug}/stats/models-by-manufacturer`, method: 'GET', signal
    },
      );
    }




export const getFleetModelsByManufacturerQueryKey = (fleetSlug: MaybeRefOrGetter<string>,) => {
    return [
    'fleets',fleetSlug,'stats','models-by-manufacturer'
    ] as const;
    }


export const getFleetModelsByManufacturerQueryOptions = <TData = Awaited<ReturnType<typeof fleetModelsByManufacturer>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetModelsByManufacturer>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetModelsByManufacturerQueryKey(fleetSlug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetModelsByManufacturer>>> = ({ signal }) => fleetModelsByManufacturer(fleetSlug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetModelsByManufacturer>>, TError, TData>
}

export type FleetModelsByManufacturerQueryResult = NonNullable<Awaited<ReturnType<typeof fleetModelsByManufacturer>>>
export type FleetModelsByManufacturerQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleet Stats - Models by Manufacturer
 */

export function useFleetModelsByManufacturer<TData = Awaited<ReturnType<typeof fleetModelsByManufacturer>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetModelsByManufacturer>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetModelsByManufacturerQueryOptions(fleetSlug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Fleet Stats - Models by Production Status
 */
export const fleetModelsByProductionStatus = (
    fleetSlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);

      return axiosClient<PieChartStats[]>(
      {url: `/fleets/${fleetSlug}/stats/models-by-production-status`, method: 'GET', signal
    },
      );
    }




export const getFleetModelsByProductionStatusQueryKey = (fleetSlug: MaybeRefOrGetter<string>,) => {
    return [
    'fleets',fleetSlug,'stats','models-by-production-status'
    ] as const;
    }


export const getFleetModelsByProductionStatusQueryOptions = <TData = Awaited<ReturnType<typeof fleetModelsByProductionStatus>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetModelsByProductionStatus>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetModelsByProductionStatusQueryKey(fleetSlug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetModelsByProductionStatus>>> = ({ signal }) => fleetModelsByProductionStatus(fleetSlug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetModelsByProductionStatus>>, TError, TData>
}

export type FleetModelsByProductionStatusQueryResult = NonNullable<Awaited<ReturnType<typeof fleetModelsByProductionStatus>>>
export type FleetModelsByProductionStatusQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleet Stats - Models by Production Status
 */

export function useFleetModelsByProductionStatus<TData = Awaited<ReturnType<typeof fleetModelsByProductionStatus>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetModelsByProductionStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetModelsByProductionStatusQueryOptions(fleetSlug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Fleet Stats - Models by Size
 */
export const fleetModelsBySize = (
    fleetSlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);

      return axiosClient<PieChartStats[]>(
      {url: `/fleets/${fleetSlug}/stats/models-by-size`, method: 'GET', signal
    },
      );
    }




export const getFleetModelsBySizeQueryKey = (fleetSlug: MaybeRefOrGetter<string>,) => {
    return [
    'fleets',fleetSlug,'stats','models-by-size'
    ] as const;
    }


export const getFleetModelsBySizeQueryOptions = <TData = Awaited<ReturnType<typeof fleetModelsBySize>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetModelsBySize>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetModelsBySizeQueryKey(fleetSlug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetModelsBySize>>> = ({ signal }) => fleetModelsBySize(fleetSlug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetModelsBySize>>, TError, TData>
}

export type FleetModelsBySizeQueryResult = NonNullable<Awaited<ReturnType<typeof fleetModelsBySize>>>
export type FleetModelsBySizeQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleet Stats - Models by Size
 */

export function useFleetModelsBySize<TData = Awaited<ReturnType<typeof fleetModelsBySize>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetModelsBySize>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetModelsBySizeQueryOptions(fleetSlug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Fleet Vehicles Stats
 */
export const fleetVehiclesStats = (
    fleetSlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);

      return axiosClient<FleetVehiclesStats>(
      {url: `/fleets/${fleetSlug}/stats/vehicles`, method: 'GET', signal
    },
      );
    }




export const getFleetVehiclesStatsQueryKey = (fleetSlug: MaybeRefOrGetter<string>,) => {
    return [
    'fleets',fleetSlug,'stats','vehicles'
    ] as const;
    }


export const getFleetVehiclesStatsQueryOptions = <TData = Awaited<ReturnType<typeof fleetVehiclesStats>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetVehiclesStats>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetVehiclesStatsQueryKey(fleetSlug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetVehiclesStats>>> = ({ signal }) => fleetVehiclesStats(fleetSlug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetVehiclesStats>>, TError, TData>
}

export type FleetVehiclesStatsQueryResult = NonNullable<Awaited<ReturnType<typeof fleetVehiclesStats>>>
export type FleetVehiclesStatsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleet Vehicles Stats
 */

export function useFleetVehiclesStats<TData = Awaited<ReturnType<typeof fleetVehiclesStats>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetVehiclesStats>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetVehiclesStatsQueryOptions(fleetSlug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Fleet Stats - Vehicles by Model
 */
export const fleetVehiclesByModel = (
    fleetSlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);

      return axiosClient<BarChartStats[]>(
      {url: `/fleets/${fleetSlug}/stats/vehicles-by-model`, method: 'GET', signal
    },
      );
    }




export const getFleetVehiclesByModelQueryKey = (fleetSlug: MaybeRefOrGetter<string>,) => {
    return [
    'fleets',fleetSlug,'stats','vehicles-by-model'
    ] as const;
    }


export const getFleetVehiclesByModelQueryOptions = <TData = Awaited<ReturnType<typeof fleetVehiclesByModel>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetVehiclesByModel>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetVehiclesByModelQueryKey(fleetSlug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetVehiclesByModel>>> = ({ signal }) => fleetVehiclesByModel(fleetSlug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetVehiclesByModel>>, TError, TData>
}

export type FleetVehiclesByModelQueryResult = NonNullable<Awaited<ReturnType<typeof fleetVehiclesByModel>>>
export type FleetVehiclesByModelQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleet Stats - Vehicles by Model
 */

export function useFleetVehiclesByModel<TData = Awaited<ReturnType<typeof fleetVehiclesByModel>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetVehiclesByModel>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetVehiclesByModelQueryOptions(fleetSlug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Public Fleet Members Stats
 */
export const publicFleetMembersStats = (
    fleetSlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);

      return axiosClient<FleetMembersStatsPublic>(
      {url: `/public/fleets/${fleetSlug}/stats/members`, method: 'GET', signal
    },
      );
    }




export const getPublicFleetMembersStatsQueryKey = (fleetSlug: MaybeRefOrGetter<string>,) => {
    return [
    'public','fleets',fleetSlug,'stats','members'
    ] as const;
    }


export const getPublicFleetMembersStatsQueryOptions = <TData = Awaited<ReturnType<typeof publicFleetMembersStats>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicFleetMembersStats>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getPublicFleetMembersStatsQueryKey(fleetSlug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof publicFleetMembersStats>>> = ({ signal }) => publicFleetMembersStats(fleetSlug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof publicFleetMembersStats>>, TError, TData>
}

export type PublicFleetMembersStatsQueryResult = NonNullable<Awaited<ReturnType<typeof publicFleetMembersStats>>>
export type PublicFleetMembersStatsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Public Fleet Members Stats
 */

export function usePublicFleetMembersStats<TData = Awaited<ReturnType<typeof publicFleetMembersStats>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicFleetMembersStats>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPublicFleetMembersStatsQueryOptions(fleetSlug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Public Fleet Models by Classification
 */
export const publicFleetModelsByClassification = (
    fleetSlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);

      return axiosClient<PieChartStats[]>(
      {url: `/public/fleets/${fleetSlug}/stats/models-by-classification`, method: 'GET', signal
    },
      );
    }




export const getPublicFleetModelsByClassificationQueryKey = (fleetSlug: MaybeRefOrGetter<string>,) => {
    return [
    'public','fleets',fleetSlug,'stats','models-by-classification'
    ] as const;
    }


export const getPublicFleetModelsByClassificationQueryOptions = <TData = Awaited<ReturnType<typeof publicFleetModelsByClassification>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicFleetModelsByClassification>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getPublicFleetModelsByClassificationQueryKey(fleetSlug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof publicFleetModelsByClassification>>> = ({ signal }) => publicFleetModelsByClassification(fleetSlug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof publicFleetModelsByClassification>>, TError, TData>
}

export type PublicFleetModelsByClassificationQueryResult = NonNullable<Awaited<ReturnType<typeof publicFleetModelsByClassification>>>
export type PublicFleetModelsByClassificationQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Public Fleet Models by Classification
 */

export function usePublicFleetModelsByClassification<TData = Awaited<ReturnType<typeof publicFleetModelsByClassification>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicFleetModelsByClassification>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPublicFleetModelsByClassificationQueryOptions(fleetSlug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Public Fleet Models by Manufacturer
 */
export const publicFleetModelsByManufacturer = (
    fleetSlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);

      return axiosClient<PieChartStats[]>(
      {url: `/public/fleets/${fleetSlug}/stats/models-by-manufacturer`, method: 'GET', signal
    },
      );
    }




export const getPublicFleetModelsByManufacturerQueryKey = (fleetSlug: MaybeRefOrGetter<string>,) => {
    return [
    'public','fleets',fleetSlug,'stats','models-by-manufacturer'
    ] as const;
    }


export const getPublicFleetModelsByManufacturerQueryOptions = <TData = Awaited<ReturnType<typeof publicFleetModelsByManufacturer>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicFleetModelsByManufacturer>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getPublicFleetModelsByManufacturerQueryKey(fleetSlug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof publicFleetModelsByManufacturer>>> = ({ signal }) => publicFleetModelsByManufacturer(fleetSlug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof publicFleetModelsByManufacturer>>, TError, TData>
}

export type PublicFleetModelsByManufacturerQueryResult = NonNullable<Awaited<ReturnType<typeof publicFleetModelsByManufacturer>>>
export type PublicFleetModelsByManufacturerQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Public Fleet Models by Manufacturer
 */

export function usePublicFleetModelsByManufacturer<TData = Awaited<ReturnType<typeof publicFleetModelsByManufacturer>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicFleetModelsByManufacturer>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPublicFleetModelsByManufacturerQueryOptions(fleetSlug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Public Fleet Models by Production Status
 */
export const publicFleetModelsByProductionStatus = (
    fleetSlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);

      return axiosClient<PieChartStats[]>(
      {url: `/public/fleets/${fleetSlug}/stats/models-by-production-status`, method: 'GET', signal
    },
      );
    }




export const getPublicFleetModelsByProductionStatusQueryKey = (fleetSlug: MaybeRefOrGetter<string>,) => {
    return [
    'public','fleets',fleetSlug,'stats','models-by-production-status'
    ] as const;
    }


export const getPublicFleetModelsByProductionStatusQueryOptions = <TData = Awaited<ReturnType<typeof publicFleetModelsByProductionStatus>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicFleetModelsByProductionStatus>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getPublicFleetModelsByProductionStatusQueryKey(fleetSlug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof publicFleetModelsByProductionStatus>>> = ({ signal }) => publicFleetModelsByProductionStatus(fleetSlug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof publicFleetModelsByProductionStatus>>, TError, TData>
}

export type PublicFleetModelsByProductionStatusQueryResult = NonNullable<Awaited<ReturnType<typeof publicFleetModelsByProductionStatus>>>
export type PublicFleetModelsByProductionStatusQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Public Fleet Models by Production Status
 */

export function usePublicFleetModelsByProductionStatus<TData = Awaited<ReturnType<typeof publicFleetModelsByProductionStatus>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicFleetModelsByProductionStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPublicFleetModelsByProductionStatusQueryOptions(fleetSlug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Public Fleet Models by Size
 */
export const publicFleetModelsBySize = (
    fleetSlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);

      return axiosClient<PieChartStats[]>(
      {url: `/public/fleets/${fleetSlug}/stats/models-by-size`, method: 'GET', signal
    },
      );
    }




export const getPublicFleetModelsBySizeQueryKey = (fleetSlug: MaybeRefOrGetter<string>,) => {
    return [
    'public','fleets',fleetSlug,'stats','models-by-size'
    ] as const;
    }


export const getPublicFleetModelsBySizeQueryOptions = <TData = Awaited<ReturnType<typeof publicFleetModelsBySize>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicFleetModelsBySize>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getPublicFleetModelsBySizeQueryKey(fleetSlug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof publicFleetModelsBySize>>> = ({ signal }) => publicFleetModelsBySize(fleetSlug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof publicFleetModelsBySize>>, TError, TData>
}

export type PublicFleetModelsBySizeQueryResult = NonNullable<Awaited<ReturnType<typeof publicFleetModelsBySize>>>
export type PublicFleetModelsBySizeQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Public Fleet Models by Size
 */

export function usePublicFleetModelsBySize<TData = Awaited<ReturnType<typeof publicFleetModelsBySize>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicFleetModelsBySize>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPublicFleetModelsBySizeQueryOptions(fleetSlug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Public Fleet Vehicles Stats
 */
export const publicFleetVehiclesStats = (
    fleetSlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);

      return axiosClient<FleetVehiclesStats>(
      {url: `/public/fleets/${fleetSlug}/stats/vehicles`, method: 'GET', signal
    },
      );
    }




export const getPublicFleetVehiclesStatsQueryKey = (fleetSlug: MaybeRefOrGetter<string>,) => {
    return [
    'public','fleets',fleetSlug,'stats','vehicles'
    ] as const;
    }


export const getPublicFleetVehiclesStatsQueryOptions = <TData = Awaited<ReturnType<typeof publicFleetVehiclesStats>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicFleetVehiclesStats>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getPublicFleetVehiclesStatsQueryKey(fleetSlug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof publicFleetVehiclesStats>>> = ({ signal }) => publicFleetVehiclesStats(fleetSlug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof publicFleetVehiclesStats>>, TError, TData>
}

export type PublicFleetVehiclesStatsQueryResult = NonNullable<Awaited<ReturnType<typeof publicFleetVehiclesStats>>>
export type PublicFleetVehiclesStatsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Public Fleet Vehicles Stats
 */

export function usePublicFleetVehiclesStats<TData = Awaited<ReturnType<typeof publicFleetVehiclesStats>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicFleetVehiclesStats>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPublicFleetVehiclesStatsQueryOptions(fleetSlug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Public Fleet Vehicles by Model
 */
export const publicFleetVehiclesByModel = (
    fleetSlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);

      return axiosClient<BarChartStats[]>(
      {url: `/public/fleets/${fleetSlug}/stats/vehicles-by-model`, method: 'GET', signal
    },
      );
    }




export const getPublicFleetVehiclesByModelQueryKey = (fleetSlug: MaybeRefOrGetter<string>,) => {
    return [
    'public','fleets',fleetSlug,'stats','vehicles-by-model'
    ] as const;
    }


export const getPublicFleetVehiclesByModelQueryOptions = <TData = Awaited<ReturnType<typeof publicFleetVehiclesByModel>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicFleetVehiclesByModel>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getPublicFleetVehiclesByModelQueryKey(fleetSlug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof publicFleetVehiclesByModel>>> = ({ signal }) => publicFleetVehiclesByModel(fleetSlug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof publicFleetVehiclesByModel>>, TError, TData>
}

export type PublicFleetVehiclesByModelQueryResult = NonNullable<Awaited<ReturnType<typeof publicFleetVehiclesByModel>>>
export type PublicFleetVehiclesByModelQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Public Fleet Vehicles by Model
 */

export function usePublicFleetVehiclesByModel<TData = Awaited<ReturnType<typeof publicFleetVehiclesByModel>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicFleetVehiclesByModel>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPublicFleetVehiclesByModelQueryOptions(fleetSlug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






